import {
    useState,
} from 'react'
import Button from 'app/shared-components/Button'
import ButtonContainer from 'app/shared-components/ButtonContainer'

import {
    StorageTableType,
} from '../../../serviceCenters.types'
import StorageForm from '../StorageForm'

const StorageCreate = ({
    closeCreateForm,
    onAddStorage,
}: {
    closeCreateForm: () => void,
    onAddStorage: (newStorage: StorageTableType) => void,
}) => {
    const [
        data,
        setData,
    ] = useState<StorageTableType | {}>({})

    const onAdd = () => {
        setData({})
        onAddStorage(data)
    }

    const onCancel = () => {
        setData({})
        closeCreateForm()
    }

    return (
        <div>
            <StorageForm
                value={data as StorageTableType}
                onChange={setData}
            />
            <ButtonContainer>
                <Button
                    label="Add"
                    onClick={onAdd}
                    data-testid="add-storage-button"
                />
                <Button
                    secondary
                    label="Cancel"
                    onClick={onCancel}
                    data-testid="cancel-storage-button"
                />
            </ButtonContainer>
        </div>
    )
}

export default StorageCreate
